// extracted by mini-css-extract-plugin
export default {"root":"vLFHn","requirement":"VFO6_","description":"AZVZ0","fulfilled":"OgNy4","notFulfilled":"TBy1m"};